import { createTextField } from 'utils/Text';
import { zeroPad } from 'utils/utils';
import { FONT_TITLE, FONT_COLOUR_LEVEL_WIN, FONT_COLOUR_STROKE, FONT_COLOUR_PAUSED } from 'app/constants/AppConstants';

import BackgroundColourFill from 'app/display/backgrounds/BackgroundColourFill';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';

export default class WarningDisplay extends Phaser.Group {
  constructor({ game }) {
    super(game);

    this.game = game;
    this.container = this.game.make.group();
    this.fixedToCamera = true;

    this.background = new BackgroundColourFill({ game: this.game, colour: '#000000', alpha: 0.7, blockInput: true });
    this.add(this.background);

    this.panel = this.game.make.image(0, 0, 'ui', 'panel_warning');
    this.panel.scale.set(0.8);

    // play again button
    this.btnPlay = new ButtonSimple({ game: this.game, id: 'btn_play', skin: 'btn_play', defaultScale: 0.5 });
    this.btnPlay.scale.set(0.5);
    this.btnPlay.position.set(this.panel.width * 0.5, this.panel.height * 0.5);
    // this.btnPlay.onInputDown.add(this.handlePlayGame, this);

    this.titleCopy = createTextField(this.game, FONT_TITLE, 84, FONT_COLOUR_LEVEL_WIN, 0, 0, {
      align: 'center',
      stroke: FONT_COLOUR_STROKE,
      strokeThickness: 6,
    });
    this.titleCopy.text = this.game.copy.getCopy('warning');
    this.titleCopy.anchor.set(0.5);
    this.titleCopy.position.set(this.panel.width * 0.5, this.panel.y);
    this.titleCopy.setShadow(3, 3, 'rgba(0,0,0,0.5)', 0);

    this.bodyCopy = createTextField(this.game, FONT_TITLE, 32, FONT_COLOUR_PAUSED, 0, 0, {
      align: 'center',
      stroke: FONT_COLOUR_STROKE,
      strokeThickness: 6,
      wordWrap: true,
      wordWrapWidth: this.panel.width * 0.9,
    });
    this.bodyCopy.text = this.game.copy.getCopy('warning_body');
    this.bodyCopy.anchor.set(0.5);
    this.bodyCopy.position.set(this.panel.width * 0.5, this.panel.y + this.panel.height * 0.2);
    this.bodyCopy.setShadow(3, 3, 'rgba(0,0,0,0.5)', 0);

    this.container.add(this.panel);
    this.container.add(this.btnPlay);
    this.container.add(this.titleCopy);
    this.container.add(this.bodyCopy);
    this.add(this.container);

    // positioning
    this.game.scale.onSizeChange.add(this.handleScreenResize, this);
    this.handleScreenResize();
  }

  handleScreenResize() {
    this.container.x = this.game.width * 0.5 - this.width * 0.5;
    this.container.y = this.game.height * 0.5 - this.height * 0.5;

    this.background.width = this.game.width;
    this.background.height = this.game.height;
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get height() {
    return this.panel.height + this.panel.y;
  }

  get width() {
    return this.panel.width;
  }

  destroy() {
    this.btnPlay.onInputDown.removeAll();
    this.game.scale.onSizeChange.remove(this.handleScreenResize, this);
    super.destroy(true);
  }
}
